module.exports = __webpack_public_path__ + "static/media/reception.929dac2f.jpg";